import { render, staticRenderFns } from "./GlobalPartnersProductListView.vue?vue&type=template&id=a1856f66&scoped=true"
import script from "./GlobalPartnersProductListView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersProductListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1856f66",
  null
  
)

export default component.exports